import React, { useState, useEffect } from "react";
import apiClient from "../../config/axiosConfig";

export const ListaParticipantes = ({ setActiveConversation, onSelectParticipante }) => {
  const [participantes, setParticipantes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiClient
      .get("/chat-privado/participantes")
      .then((res) => setParticipantes(res.data))
      .catch(() => setError("No se pudo cargar la lista de participantes."))
      .finally(() => setCargando(false));
  }, []);

  const handleChatear = (participante) => {
    setActiveConversation(participante.id);
    onSelectParticipante(participante);
  };

  if (cargando) {
    return (
      <div className="private-chat__participantes-loading">
        Cargando participantes...
      </div>
    );
  }

  if (error) {
    return (
      <div className="private-chat__participantes-error">{error}</div>
    );
  }

  return (
    <ul className="private-chat__participantes-lista">
      {participantes.map((participante) => (
        <li key={participante.id} className="private-chat__participante-item">
          <span className="private-chat__participante-nombre">
            {participante.nombre}
          </span>
          <button
            className="private-chat__participante-btn"
            onClick={() => handleChatear(participante)}
          >
            Chatear
          </button>
        </li>
      ))}
      {participantes.length === 0 && (
        <li className="private-chat__participantes-vacio">
          No hay otros participantes disponibles.
        </li>
      )}
    </ul>
  );
};
